const isMock = false,
  apiVersion = "v0",
  urlProtocol =
    !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV?.trim() === "com"
      ? "https"
      : "http",
  urlType = process.env.REACT_APP_ENV?.trim() || "com",
  isLocalhost = process.env.REACT_APP_ENV?.trim() === "localhost",
  mockUrl = `http://0.0.0.0:5000/${apiVersion}`;

export default {
  urlType: urlType,
  urlProtocol: urlProtocol,
  isProduction: urlType === "com",
  authenticateUrl: isLocalhost
    ? `http://localhost:34300`
    : `${urlProtocol}://account.3gaam.${urlType}`,
  hallUrl: `${urlProtocol}://3gaam.${urlType}/bio`,
  joinUrl: `${urlProtocol}://3gaam.${urlType}/join`,
  appUrl: `${urlProtocol}://app.3gaam.${urlType}`,
  shopUrl: `${urlProtocol}://shop.3gaam.${urlType}`,
  finalUrl: `${urlProtocol}://final.3gaam.${urlType}`,
  planningLandingUrl: `${urlProtocol}://3gaam.${urlType}/landings/planning`,
  aboutUsUrl: `${urlProtocol}://3gaam.${urlType}/home/aboutus`,
  contactUsUrl: `${urlProtocol}://3gaam.${urlType}/home/contactus`,
  faqUrl: `${urlProtocol}://3gaam.${urlType}/home/faq`,
  policiesUrl: `${urlProtocol}://3gaam.${urlType}/home/policies`,
  pricingUrl: `${urlProtocol}://3gaam.${urlType}/pricing`,
  serviceQualityUrl: `https://3gaam.com/notification/3438/%D8%AA%D8%B6%D9%85%DB%8C%D9%86-%DA%A9%DB%8C%D9%81%DB%8C%D8%AA-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA`,
  magUrl: `${urlProtocol}://3gaam.${urlType}/mag`,
  mainUrl: `${urlProtocol}://3gaam.${urlType}`,
  apiUrl: {
    account: isLocalhost
      ? `http://localhost:34301/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://account-api.3gaam.${urlType}/${apiVersion}`,
    communication: isLocalhost
      ? `http://localhost:34301/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://communication-api.3gaam.${urlType}/${apiVersion}`,
    consultancy: isLocalhost
      ? `http://localhost:34304/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://consultancy-api.3gaam.${urlType}/${apiVersion}`,
    planning: isLocalhost
      ? `http://localhost:34304/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://planning-api.3gaam.${urlType}/${apiVersion}`,
    essentials: isLocalhost
      ? `http://localhost:34303/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://essentials-api.3gaam.${urlType}/${apiVersion}`,
    store: isLocalhost
      ? `http://localhost:34305/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://store-api.3gaam.${urlType}/${apiVersion}`,
    notification: isLocalhost
      ? `http://localhost:34305/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://notification-api.3gaam.${urlType}/${apiVersion}`,
    generic: isLocalhost
      ? `http://localhost:34305/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://generic-api.3gaam.${urlType}/${apiVersion}`,
    private: isLocalhost
      ? `http://localhost:34305/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://private-api.3gaam.${urlType}/${apiVersion}`,
    cms: isLocalhost
      ? `http://localhost:34305/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://cms-api.3gaam.${urlType}/${apiVersion}`,
  },
  intervalChatRequestTime: 15000,
  asciiMessage: `
    _______  _______  _______  _______  __   __ 
    |       ||       ||   _   ||   _   ||  |_|  |
    |___    ||    ___||  |_|  ||  |_|  ||       |
    ___|   ||   | __ |       ||       ||       |
    |___    ||   ||  ||       ||       ||       |
    ___|   ||   |_| ||   _   ||   _   || ||_|| |
    |_______||_______||__| |__||__| |__||_|   |_|

  `,
};
